<template>
  <div class="account" ref="accountRef">
    <div class="head">
      <p>Bank Information<span v-if="!props.accountInfo.bankCountry">*</span>
        <span
          :class="['bank-review-status', props.accountInfo.bankInformationReviewStatus?.toLowerCase() || 'pending']">
          <i class="iconfont icon-dengdai"
            v-if="!props.accountInfo.bankInformationReviewStatus || props.accountInfo.bankInformationReviewStatus == 'Pending'" />
          <i class="iconfont icon-a-error-tianchong5"
            v-else-if="props.accountInfo.bankInformationReviewStatus == 'Rejected'" />
          <i class="iconfont icon-success-tianchong"
            v-else-if="props.accountInfo.bankInformationReviewStatus == 'Approved'" />
          <em>{{ !props.accountInfo.bankInformationReviewStatus || props.accountInfo.bankInformationReviewStatus ===
            'Pending' ? 'Pending Approval' :
            props.accountInfo.bankInformationReviewStatus }}</em>
          <a-popover trigger="hover" placement="bottom"
            v-if="props.accountInfo.bankInformationReviewStatus === 'Rejected' && props.accountInfo.reason.length"
            overlayClassName="reject-reason-popover" :getPopupContainer="() => $refs.accountRef">
            <template #content>
              <p class="reject-reason">{{ props.accountInfo.reason }}</p>
              <p class="tip"><i class="iconfont icon-a-warring-tianchong3" />Please update and resubmit for approval.
              </p>
            </template>
            <i class="iconfont icon-wenhao-tianchong" />
          </a-popover>
        </span>
      </p>
      <artmisads-select-button @click="() => setShowModal(true)" size="middle" :showEditIcon="true">Update Bank
        Info</artmisads-select-button>
    </div>
    <div class="cont">
      <div class="item">
        <div class="item-left">
          <span class="name">Bank Name:</span>
          <span class="text" v-if="props.accountInfo.bankName">{{ props.accountInfo.bankName }}</span>
          <span class="no-data" v-else>--</span>
        </div>
        
        <div class="item-right">
          <span class="name">Bank Location Country:</span>
          <span class="text" v-if="props.accountInfo.bankCountry">{{
            props.countryListMap[props.accountInfo.bankCountry]?.label }}</span>
          <span class="no-data" v-else>--</span>
        </div>
      </div>
      <div class="item">
        <div class="item-left">
          <span class="name">Account Beneficiary Name:</span>
          <span class="text" v-if="props.accountInfo.accountName">{{ props.accountInfo.accountName }}</span>
          <span class="no-data" v-else>--</span>
        </div>
        <div class="item-right">
          <span class="name">Bank Account Number:</span>
          <span class="text" v-if="props.accountInfo.bankAccountNumber">{{ props.accountInfo.bankAccountNumber }}</span>
          <span class="no-data" v-else>--</span>
        </div>
        
      </div>
      <div class="item">
        <div class="item-left">
          <span class="name">Bank Routing Number: </span>
          <span class="text" v-if="props.accountInfo.bankRountingNumber">{{ props.accountInfo.bankRountingNumber
          }}</span>
          <span class="no-data" v-else>--</span>
        </div>
      </div>
    </div>
    <editAccountInfoModal :accountInfo="props.accountInfo" :setShowModal="setShowModal" :countryList="countryList"
      v-if="showModal" />
  </div>
</template>
<script setup>
import { ref } from 'vue'
import editAccountInfoModal from './editAccountInfoModal.vue'
const props = defineProps(['accountInfo', 'getData', 'countryList', 'countryListMap'])

const showModal = ref(false)

const setShowModal = (status, reload) => {
  showModal.value = status
  if (reload) {
    props.getData()
  }
}

</script>
<style lang="less" scoped>
.account {
  padding: 16px 0 24px 16px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  box-shadow: var(--section-box-shadow-6);

  :deep(.reject-reason-popover) {
    width: 320px;

    .reject-reason {
      font-size: 13px;
      line-height: 20px;
      margin-bottom: 13px;
      color: var(--dark-1);
      letter-spacing: 0.3px;
      word-break: break-word;
    }

    .tip {
      margin: 0;
      display: flex;
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
      align-items: center;
      color: var(--dark-1);
      letter-spacing: 0.3px;

      >.iconfont {
        width: 16px;
        height: 16px;
        line-height: 16px;
        margin-right: 5px;
        color: var(--yellow-7);
      }
    }
  }

  .head {
    padding: 0 16px 16px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--border-4);

    >p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;

      >span {
        color: var(--red-text);
        margin-left: 3px;
        font-size: 16px;
        font-weight: 600;
        line-height: 32px;
      }

      .bank-review-status {
        height: 20px;
        font-size: 16px;
        margin-left: 8px;
        line-height: 20px;
        border-radius: 4px;
        align-items: center;
        font-weight: normal;
        color: var(--dark-1);
        display: inline-flex;
        padding: 0 6px 0 4px;
        background: var(--bg-gray-8);

        &.rejected {
          color: #fff;
          background: var(--red-bg);
        }

        >.iconfont {
          width: auto;
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          margin-right: 6px;
        }

        >.icon-dengdai {
          color: var(--yellow-7);
        }

        >.icon-a-error-tianchong5 {
          color: #fff;
        }

        >.icon-success-tianchong {
          color: var(--green-3);
        }

        .icon-wenhao-tianchong {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-left: 6px;
          line-height: 20px;
          text-align: center;
          margin-right: -6px;
          border-radius: 0 4px 4px 0;
          color: rgba(255, 255, 255, 0.7);
          box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.3);
        }

        >em {
          height: 16px;
          font-size: 12px;
          line-height: 16px;
          font-style: normal;
          letter-spacing: 0.3px;
        }
      }
    }
  }

  .cont {
    padding-right: 16px;

    .item {
      display: flex;
      margin-top: 24px;
    }

    .item-right {
      margin-left: 16px;
    }

    .item-right,
    .item-left {
      width: 50%;
      display: flex;
      flex-direction: column;

      .name {
        font-weight: 400;
        font-size: 13px;
        color: var(--dark-3);
        letter-spacing: 0.3px;
        line-height: 18px;
      }

      .text {
        font-weight: 600;
        font-size: 14px;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        line-height: 20px;
        margin-top: 4px;
        word-break: break-all;
      }

      .no-data {
        font-weight: 500;
        font-size: 14px;
        color: var(--dark-4);
        letter-spacing: 0.4px;
        line-height: 20px;
        margin-top: 4px;
      }
    }
  }
}
</style>
